import React, { useState } from 'react'
import { Dropdown, Layout, Badge, Tooltip, Button } from "antd";
import { logout } from '@mods/userManagement/auth/authSlice'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import AvatarImg from '@assets/images/avatar.png'
import { Icon } from '@iconify/react';
import UserCaseChatBox from "@mods/userCase/components/UserCaseChatBox"
import CommandSearch from "./CommandSearch";
import LogoutModal from "./LogoutModal";
import "./header.css";

const { Header } = Layout;

const TopHeader = (props) => {
  const [chatOpen, setChatOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const authUser = useSelector((state) => state.auth.authUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    setLogoutOpen(false);
    dispatch(logout());
    navigate('/');
  };

  const avatar = authUser && authUser.image
    ? process.env.REACT_APP_BASE_URL + authUser.image
    : AvatarImg;

  const unread = (props.notification && props.notification.cases_chat) || 0;

  const accountMenu = {
    items: [
      {
        key: 'identity',
        type: 'group',
        label: (
          <div className="account-identity">
            <img className="account-identity-avatar" src={ avatar } alt="" />
            <span className="account-identity-meta">
              <span className="account-identity-name">{ authUser && authUser.name }</span>
              <span className="account-identity-email">{ authUser && authUser.email }</span>
            </span>
          </div>
        ),
      },
      { type: 'divider' },
      {
        key: 'profile',
        icon: <Icon icon="tabler:user-circle" width={ 18 } />,
        label: 'My profile',
        onClick: () => navigate('/profile'),
      },
      {
        key: 'password',
        icon: <Icon icon="tabler:lock" width={ 18 } />,
        label: 'Change password',
        onClick: () => navigate('/change-password'),
      },
      { type: 'divider' },
      {
        key: 'logout',
        danger: true,
        icon: <Icon icon="tabler:logout" width={ 18 } />,
        label: 'Log out',
        onClick: () => setLogoutOpen(true),
      },
    ],
  };

  return (
    <>
      { chatOpen
        ? <UserCaseChatBox setChatOpen={ setChatOpen } />
        : <div onClick={ () => setChatOpen(true) } className="chatLoader" role="button" aria-label="Open case chat">
          { unread > 0 && <span className="chat-fab-dot" /> }
          <Icon icon="tabler:message-circle" width={ 24 } />
        </div>
      }

      <Header className="topheader headermenu">
        <div className="topbar">
          <div className="topbar-left">
            {/* the rail is always open on desktop, so this button only has
                a job below 992px, where it opens the drawer */ }
            { props.mobile &&
              <button
                type="button"
                className="topbar-icon-btn"
                onClick={ props.onToggleNav }
                aria-label="Open navigation"
              >
                <Icon icon="tabler:menu-2" width={ 22 } />
              </button> }
            <h1 className="topbar-title">{ props.title || "Dashboard" }</h1>
          </div>

          <div className="topbar-centre">
            <CommandSearch />
          </div>

          <div className="topbar-right">
            <Tooltip title="Case chat">
              <button
                type="button"
                className="topbar-icon-btn topbar-chat"
                onClick={ () => setChatOpen(true) }
                aria-label="Open case chat"
              >
                <Badge count={ unread } size="small" offset={ [2, -2] }>
                  <Icon icon="tabler:message-circle" width={ 21 } />
                </Badge>
              </button>
            </Tooltip>

            <Dropdown menu={ accountMenu } trigger={ ['click'] } placement="bottomRight"
              overlayClassName="account-menu">
              <Button type="text" className="account-trigger">
                <img className="account-avatar" src={ avatar } alt="" />
                <span className="account-name">{ authUser && authUser.name }</span>
                <Icon icon="tabler:chevron-down" width={ 16 } className="account-caret" />
              </Button>
            </Dropdown>
          </div>
        </div>
      </Header>

      { logoutOpen &&
        <LogoutModal
          open
          user={ authUser }
          avatar={ avatar }
          onConfirm={ handleLogout }
          onCancel={ () => setLogoutOpen(false) }
        /> }
    </>
  );
};

export default TopHeader;
